// import $ from 'jquery' // jQuery
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
if (document.getElementById('page-impressed')) {
  pageImpressed()
}

function pageImpressed() {
  //  #####     ###    #####      ###              ######   #####    #####   ###    ###
  //  ##  ##   ## ##   ##  ##    ## ##                ##   ##   ##  ##   ##  ## #  # ##
  //  #####   ##   ##  #####    ##   ##  ########    ##    ##   ##  ##   ##  ##  ##  ##
  //  ##      #######  ##  ##   #######             ##     ##   ##  ##   ##  ##      ##
  //  ##      ##   ##  ##   ##  ##   ##            ######   #####    #####   ##      ##

  // 背景の円を広げる
  scrollParallax()
  function scrollParallax() {
    if (!document.getElementById('circle')) {
      return
    }

    gsap.registerPlugin(ScrollTrigger) // スクロールトリガー起動

    const startLine = window.matchMedia('(min-width:769px)').matches ? 500 : -150
    const endLine = window.matchMedia('(min-width:769px)').matches ? startLine + 1600 : 150

    gsap.utils.toArray('#circle').forEach((wrap) => {
      gsap.to(wrap, {
        width: '300vmax',
        height: '300vmax',
        scrollTrigger: {
          trigger: wrap, // ターゲット要素
          start: 'top+=' + startLine + ' top', // 開始位置
          end: 'top+=' + endLine + ' top', // 終了位置
          scrub: 1, // 補正倍率
          // markers: true, // デバッグ表示
        },
      })
    })
  }

  //            ##       #####    ####  ##  ##
  //            ##      ##   ##  ##     ## ##
  //  ########  ##      ##   ##  ##     ####
  //            ##      ##   ##  ##     ## ##
  //            ######   #####    ####  ##  ##
  // モーダル展開中は最大で固定する
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    document.getElementById('circle').classList.add('lock')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    document.getElementById('circle').classList.remove('lock')
  })
}
